import { createContext } from "react";
import type { PanelLayoutChoice } from "_shared/_views/panels/_api/panel-layout-preferences-api";

/**
 * Where a panel finds how the reader keeps it, as their account remembers it (#6621).
 *
 * Its own module, apart from the provider that fills it, as `TableColumnPreferencesContext` is: a
 * panel drawn without the provider — every spec that renders one — has no server to talk to, and
 * keeps the reader's choice for as long as it is on screen.
 */
export type PanelLayoutPreferences = {
  /** Every panel the reader has a saved choice for, once the server has answered; `undefined` before. */
  savedPanels: ReadonlyMap<string, PanelLayoutChoice> | undefined;
  /** Saves one panel's whole choice for the signed-in reader. Fire and forget: a failure is logged. */
  savePanel: (panelKey: string, choice: PanelLayoutChoice) => void;
};

export const PanelLayoutPreferencesContext = createContext<PanelLayoutPreferences | undefined>(undefined);
